import { z } from 'zod'

export const subscriptionPlanSchema = z.object({
  id: z.string(),
  company_id: z.string().nullable().optional(),
  base_plan_id: z.string().nullable().optional(),
  name: z.string().min(1, 'Nome do plano não pode ser vazio'),
  price: z.number(),
  setup_fee: z.number().optional(),
  allowed_modules: z.array(z.string()).optional().default([]),
  max_bank_accounts: z.number(),
  max_payments: z.number(),
  max_billets: z.number(),
  max_invoices: z.number(),
  active: z.boolean(),
  description: z.string().nullable().optional(),
  trial_days: z.number().nullable().optional(),
  max_companies: z.number().nullable().optional(),
  overage_price_billet: z.number().nullable().optional(),
  overage_price_invoice: z.number().nullable().optional(),
  overage_price_payment: z.number().nullable().optional(),
  allow_annual_billing: z.boolean().optional().default(true),
  annual_discount_percentage: z.number().optional().default(20.00),
  annual_price: z.number().optional(),
  annual_monthly_equivalent: z.number().optional(),
  annual_savings: z.number().optional(),
  whitelabel_discount_percentage: z.number().optional().default(0),
  seven_base_price: z.number().optional(),
  whitelabel_cost_price: z.number().optional(),
  whitelabel_margin_amount: z.number().optional(),
  is_custom_priced: z.boolean().optional(),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
  asaas_plan_id: z.string().nullable().optional(),
  payment_url: z.string().nullable().optional(),
})

export type BillingCycle = 'monthly' | 'yearly' | 'annual' | 'MONTHLY' | 'YEARLY' | 'ANNUAL'

export interface SubscriptionPlan {
  id: string
  company_id?: string | null
  base_plan_id?: string | null
  name: string
  price: number
  setup_fee?: number | null
  allowed_modules?: string[] | null
  max_bank_accounts: number
  max_payments: number
  max_billets: number
  max_invoices: number
  active: boolean
  description?: string | null
  trial_days?: number | null
  max_companies?: number | null
  overage_price_billet?: number | null
  overage_price_invoice?: number | null
  overage_price_payment?: number | null
  allow_annual_billing?: boolean
  annual_discount_percentage?: number
  annual_price?: number
  annual_monthly_equivalent?: number
  annual_savings?: number
  whitelabel_discount_percentage?: number
  seven_base_price?: number
  whitelabel_cost_price?: number
  whitelabel_margin_amount?: number
  is_custom_priced?: boolean
  created_at?: string | null
  updated_at?: string | null
  asaas_plan_id?: string | null
  payment_url?: string | null
}

export interface CompanySubscription {
  id: string
  company_id: string
  plan_id: string
  status: 'active' | 'canceled' | 'past_due' | 'pending_payment'

  billing_cycle?: BillingCycle | string
  snapshot_billing_cycle?: BillingCycle | string
  snapshot_price: number
  snapshot_annual_price?: number | null
  snapshot_annual_discount_percentage?: number | null
  snapshot_setup_fee: number
  snapshot_allowed_modules: string[]
  snapshot_max_bank_accounts: number
  snapshot_max_payments: number
  snapshot_max_billets: number
  snapshot_max_invoices: number

  billing_cycle_start_day: number
  start_date: string
  end_date: string | null

  trial_end_date?: string | null
  asaas_customer_id?: string | null
  asaas_subscription_id?: string | null

  plan?: {
    name: string
  }
}

export type InvoiceStatus = 'pending' | 'paid' | 'overdue' | 'canceled'

export interface CompanyInvoice {
  id: string
  company_id: string
  amount: number
  status: InvoiceStatus
  due_date: string
  paid_at: string | null
  gateway_invoice_id: string | null
  payment_url: string | null
  receipt_url: string | null
  billing_period: string
  items: any[]
  created_at: string
  updated_at: string
}

export interface MasterBillingMetrics {
  mrr: number
  arr: number
  new_this_month: number
  canceled_this_month: number
  past_due_count: number
  churn_rate: number
}

export interface MasterBillingCompanyRow {
  company_id: string
  company_name: string
  plan_name: string | null
  subscription_status: 'active' | 'past_due' | 'canceled' | 'pending_payment' | null
  snapshot_price: number
  start_date: string | null
  days_overdue: number
  asaas_customer_id: string | null
}

